import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {Breadcrumb} from "@webs/components-library/breadcrumbs";
import {containerStyles, normalizeStyles, typographyStyles} from "@webs/components-library/theming";

@customElement('webs-header-blog')
export class HeaderBlog extends LitElement {

  static styles = [
    normalizeStyles,
    containerStyles,
    typographyStyles,
    css`

      .tp-blog-detail-header {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        padding: 2.5rem 0 0;
        position: relative;
      }

      .tp-blog-detail-header .container {
        z-index: 2;
      }

      .tp-blog-detail-header h1 {
        margin-bottom: 3rem;
        text-align: center;
      }

      .tp-blog-detail-header webs-breadcrumbs::part(container) {
        justify-content: center;
        margin-bottom: 1.2rem;
      }

      .tp-blog-detail-header webs-media::part(media) {
        padding-bottom: 127.8125vw !important;
      }

      @media only screen and (min-width: 576px){
          .tp-blog-detail-header {
            padding: 5rem 0 0;
          }

          .tp-blog-detail-header webs-media::part(media) {
            padding-bottom: 51.1805556vw !important;
          }
      }

      @media only screen and (min-width: 992px){
          .tp-blog-detail-header__intro {
            margin: 0 auto;
            max-width: 700px;
          }
      }

      @media only screen and (min-width: 1175px){
          .tp-blog-detail-header webs-media::part(media) {
            padding-bottom: 600px !important;
          }
      }

      @media only screen and (min-width: 1441px){
      :host {
        overflow-x: unset;
      }
     }
    `
  ]
  @property()
  title: string;

  @property()
  breadcrumbs: Breadcrumb[];

  protected render(): unknown {
    return html`
      <section class="tp-blog-detail-header">
        <div class="container">
          <webs-grid-row>
            <webs-grid-column md="10" md-offset="2" lg="8" class="tp-blog-detail-header__info">
              <div class="tp-blog-detail-header__intro">
                ${this.breadcrumbs && this.breadcrumbs.length ? html`<webs-breadcrumbs items='${this.breadcrumbs}'></webs-breadcrumbs>` : '' }
                <h1>${ this.title }</h1>
              </div>
            </webs-grid-column>
          </webs-grid-row>
        </div>
        <slot name="media"></slot>
      </section>
    `
  }
}
